module.exports = __webpack_public_path__ + "img/s2P1.585e67c9.png";